var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaution({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8109 18.2675L13.3286 1.17948C12.6309 0.0407002 11.4898 0.056683 10.7921 1.19546L0.309784 18.2603C-0.387866 19.3999 0.133174 20.2797 1.46774 20.2797H22.6522C23.9875 20.2797 24.5086 19.4055 23.8109 18.2675ZM12.0516 4.96181C12.7228 4.96181 13.2423 5.70341 13.2079 6.60964L12.9953 12.071C12.961 12.9764 12.535 13.718 12.0492 13.718C11.5633 13.718 11.1365 12.9764 11.1022 12.071L10.892 6.60964C10.8576 5.70341 11.3787 4.96181 12.0516 4.96181ZM12.0516 17.832C11.2045 17.832 10.6235 17.2126 10.6411 16.3664C10.6411 15.5017 11.2237 14.9007 12.0516 14.9007C12.9146 14.9007 13.4605 15.5017 13.4788 16.3664C13.4788 17.2126 12.9146 17.832 12.0516 17.832Z",
    fill: "#DE350B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaution);
export default __webpack_public_path__ + "static/media/caution.734f6b7a70fa82e297298bed32397764.svg";
export { ForwardRef as ReactComponent };